import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface ProductionTeamMember {
  id: string;
  name: string;
  image: string | null;
  bio: string;
}

export const useProductionTeam = () => {
  return useQuery({
    queryKey: ['production-team'],
    queryFn: async (): Promise<ProductionTeamMember[]> => {
      const { data: actors, error } = await supabase
        .from('actors')
        .select('id, name, bio, image_url')
        .eq('is_active', true)
        .eq('is_production_team', true)
        .order('name');

      if (error) {
        console.error('Error fetching production team:', error);
        throw error;
      }

      // Transform to match PerformersSection interface
      return actors?.map(actor => ({
        id: actor.id,
        name: actor.name,
        image: actor.image_url,
        bio: actor.bio || ''
      })) || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1
  });
};